import React, { useEffect, useState, useRef } from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { baseURL, fetch, post, postForm } from "../../Util/axios_helper";
import { useDispatch, useSelector } from "react-redux";
import { KendoLoader } from "../../Kendo/kendo_loader";
import {
  Button,
  ErrorMsg,
  GetFormData,
  InfoIcon,
  ValidateForm,
  checkAccess,
  confirmDelete,
  sessionUser,
} from "../../Util/common";
import { getClusterTypes } from "./app_config_slice";
import { toast } from "react-toastify";

export const EventType = ({ selTab }) => {
  const dispatch = useDispatch();
  const { eventType, eventTypeLoaded } = useSelector(
    (state) => state.appConfig
  );
  const [error, setError] = useState({});
  const [editVisible, setEditVisible] = useState(false);
  const [LargeFile, setLargeFile] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [event, setEvent] = useState({
    typeId: 0,
    file: "",
    eventName: "",
    imageName: "",
    oldImage: "",
  });
  const modalRef = useRef(null);
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const clearForm = () => {
    $("#hide").click();
    setLoading(false);
    setEvent({});
    setError({});
    setEditVisible(false);
    $("#btn-reset").click();
    setLargeFile(false);
  };

  useEffect(() => {
    if (selTab == 1) {
      dispatch(getClusterTypes());
      if (modalRef.current) {
        $(modalRef.current).on("hidden.bs.modal", () => {
          clearForm();
        });
      }

      return () => {
        if (modalRef.current) {
          $(modalRef.current).off("hidden.bs.modal");
        }
      };
    }
  }, [selTab]);

  const onSubmit = async (e) => {
    e.preventDefault();
    let isDuplicate = false;
    let matchingItem = eventType.find((item) => item.TypeId == event.typeId);
    let TypeNameValue = matchingItem ? matchingItem.TypeName : null;
    let dup = TypeNameValue != event.eventName;
    if (dup) {
      isDuplicate = eventType.some(
        (item) =>
          item.TypeName.trim().toLowerCase() ==
          event.eventName.trim().toLowerCase()
      );
    }

    var err = ValidateForm(e);

    if (err) {
      setError(err);
    } else if (!isDuplicate && !error.ValidFile && !LargeFile) {
      let formData = new FormData(
        document.getElementById("form-cluster-config")
      );
      formData.append("SavedBy", sessionUser());
      setLoading(true);
      if (editVisible) {
        await post(
          "Configuration/SaveEvent",
          formData,
          true,
          false,
          false,
          true
        );
      } else {
        await post("Configuration/SaveEvent", formData);
      }
      $("#ballroom-fun-cancel").click();
      clearForm();
      dispatch(getClusterTypes());
    }
  };

  const handleEditClick = async (e) => {
    setEvent({
      typeId: e.TypeId,
      eventName: e.TypeName,
      imageName: e.ImageName,
      oldImage: e.ImageName,
    });
    setEditVisible({
      visible: true,
    });
    const modal = new bootstrap.Modal(document.getElementById("add_event"));
    modal.show();
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      fetch(
        `Configuration/DeleteEvent?TypeId=${
          e.TypeId
        }&DeletedBy=${sessionUser()}&FileName=${e.ImageName}`,
        true,
        false,
        true
      ).then(() => {
        dispatch(getClusterTypes());
      });
    };
    confirmDelete(onDelete);
  };

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    const filevalid = file && !file?.type.startsWith("image/");
    const hasAvifFile = file && file?.name.endsWith(".avif");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }

    setError((prevError) => ({
      ...prevError,
      ValidFile: filevalid,
    }));
    let isFileTooLarge = false;
    if (!filevalid) {
      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;
      isFileTooLarge = file?.size > maxSizeInBytes;
      setLargeFile(isFileTooLarge);
    }

    if (file && !filevalid && !isFileTooLarge) {
      let file = e.target.files[0];
      let fileName = file.name;
      let temp = event;
      event.imageName = fileName;
      event.file = file;
      setEvent(temp);
      document.getElementById("image-name").value = fileName;
      onValidation("ImageName", e.target.value);
    }
  };

  const onRowReorderChange = async (List) => {
    await fetch(
      `Configuration/SortClusterTypes?TypeId=${List.pid}&NewOrder=${List.newIndex}&OldOrder=${List.oldIndex}`
    );
    dispatch(getClusterTypes());
  };
  return (
    <>
      <div className="col-auto ms-auto">
        <div className="row">
          <div className="col-sm-6"></div>
          {/* {checkAccess("APPCONFIGCREATE") && ( */}
          {/* <div className="col-auto float-end ms-auto">
            <div className="d-flex justify-content-end mb-2">
              <Button
                name={"Add Event"}
                dataBsToggle={"modal"}
                dataBsTarget={"#add_event"}
                dataBsDismiss={"modal"}
              />
            </div>
          </div> */}
          {/* )} */}
        </div>

        <div>
          {!eventTypeLoaded ? (
            <div className="row">
              <div className="col-12">
                <KendoLoader />
              </div>
            </div>
          ) : (
            <KendoGrid
              name={"event-config"}
              data={eventType}
              schema={{}}
              columns={[
                {
                  field: "TypeId",
                  filterable: false,
                  hidden: true,
                },
                {
                  field: "TypeName",
                  title: "Event Type",
                },
                {
                  field: "ImageName",
                  hidden: true,
                },
                {
                  template: function (e) {
                    if (e.ImageName) {
                      return `<img src="${baseURL}Configuration/GetImage?fileName=${e.ImageName}" width="40px" height: "40px" />`;
                    }
                    return "";
                  },
                  headerTemplate:
                    "<div>Image&nbsp;<span><a href='https://www.flaticon.com/authors/flat-icons' target='_blank' style='color:blue;font-size:12px;text-decoration:underline'><i>Download Icons</i></a>&nbsp;<i class='k-icon k-i-download'></i></span></div>",
                  title: "Image",
                },
              ]}
              showOptions={true}
              showEdit={true}
              showDelete={false}
              paggable={false}
              onEditClick={handleEditClick}
              onDeleteClick={handleDeleteClick}
              disableExportExcel={true}
              enableRowReorderable={true}
              onRowReorder={onRowReorderChange}
            />
          )}
        </div>
      </div>
      {/* <!-- Add Culture Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_event"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editVisible ? "Edit Event" : "Add Event"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-cluster-config" onSubmit={onSubmit}>
                <input type="hidden" name="TypeId" value={event.typeId} />
                <div className="row input-block mb-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Event Type <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="TypeName"
                      defaultValue={event.eventName}
                      placeholder="Event Type"
                      data-required="true"
                      onChange={(e) => {
                        setEvent((prev) => ({
                          ...prev,
                          eventName: e.target.value.trim(),
                        }));
                        onValidation("TypeName", e.target.value);
                        const matchingItem = eventType.find(
                          (item) => item.TypeId == event.typeId
                        );
                        const TypeNameValue = matchingItem
                          ? matchingItem.TypeName
                          : null;
                        const dup = TypeNameValue != e.target.value;
                        if (dup) {
                          const isDuplicate = eventType.some(
                            (item) =>
                              item.TypeName.trim().toLowerCase() ==
                              e.target.value.trim().toLowerCase()
                          );

                          setError((prevError) => ({
                            ...prevError,
                            ETDuplicate: isDuplicate,
                          }));
                        }
                      }}
                    />
                    {error.TypeName && (
                      <ErrorMsg text="Event Type is required" />
                    )}
                    {error.ETDuplicate && (
                      <ErrorMsg text="Event Type is already exist" />
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <label className="form-label">
                      Event Image <span className="text-danger">*</span>
                      <InfoIcon
                        content="
                                   Ensure the image size does not exceed 500KB.;
                                  Please upload the image in JPEG,JPG or PNG format."
                      />
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      name="File"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {error.ImageName && (
                      <ErrorMsg text="Event Image is required" />
                    )}
                    {error.ValidFile && (
                      <ErrorMsg text="please upload Image file only" />
                    )}
                    {LargeFile && (
                      <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                    )}
                  </div>
                  <div className="row mt-1 mb-3">
                    {event.imageName && event.typeId > 0 && (
                      <div
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={`${baseURL}Configuration/GetImage?fileName=${event.imageName}`}
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            fontSize: "13px",
                          }}
                        >
                          {event.imageName}
                        </a>
                      </div>
                    )}
                    <input
                      type="hidden"
                      name="ImageName"
                      id="image-name"
                      data-required="true"
                      value={event.imageName}
                    />
                    <input
                      type="hidden"
                      name="OldImage"
                      value={event.oldImage}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <>
                    <div className="text-end">
                      <Button
                        name={"Cancel"}
                        isCancelButton={true}
                        id="ballroom-fun-cancel"
                        dataBsDismiss={"modal"}
                        onClick={() => {
                          clearForm();
                        }}
                      />
                      <Button name={editVisible ? "Update" : "Save"} />
                    </div>
                    <button
                      type="reset"
                      id="btn-reset"
                      style={{ display: "none" }}
                    ></button>
                  </>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add Culture Modal --> */}
    </>
  );
};
